module.exports = __webpack_public_path__ + "static/media/Optimizing permission levels to share and access construction documents efficiently.4354ea5a.png";